export class ConfirmOtpBindingModel {
    phoneNumber: string;
    code: string;
    captcha:string;
}